const FeedIcon = ({
    fill = '#4A4A4A'
}) => {
    return (
        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M5.05 9.42505C5.05 6.73266 7.23262 4.55005 9.925 4.55005H17.075C19.7674 4.55005 21.95 6.73266 21.95 9.42505V16.575C21.95 19.2674 19.7674 21.45 17.075 21.45H9.925C7.23262 21.45 5.05 19.2674 5.05 16.575V9.42505ZM9.925 6.50005C8.30957 6.50005 7 7.80962 7 9.42505V10.075H20V9.42505C20 7.80962 18.6904 6.50005 17.075 6.50005H9.925ZM14.8 12.025H7V16.575C7 18.1905 8.30957 19.5 9.925 19.5H14.8V12.025ZM16.75 19.5V12.025H20V16.575C20 18.1905 18.6904 19.5 17.075 19.5H16.75Z" fill={fill} />
        </svg>

    )
}
export default FeedIcon;